import { IInterval } from "./Interval";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { TimingCallback   } from "./Timeout";
import { safeClearTimeout, safeSetTimeout } from "./SafeTiming";
export interface IRandomInterval extends IInterval
{

}

export class RandomInterval implements IRandomInterval
{
    protected resid: ResourceIdentifier;

    protected running: boolean = false;
    protected intervalid: number = 0;

    protected callback: TimingCallback = null;
    
    protected intervalFrom: number = 0;
    protected intervalTo: number = 0;
    protected currentInterval: number = 0;

    public constructor(resid: ResourceIdentifier, callback: TimingCallback, intervalFrom: number, intervalTo: number)
    {
        this.resid = resid;

        if (callback == null) throw "callback must not be null";
        this.callback = callback;

        if (intervalFrom < 0) throw "intervalFrom must be positive";
        if (intervalFrom >= intervalTo) throw "intervalFrom must be smaller than intervalTo negative";
        this.intervalFrom = intervalFrom;
        this.intervalTo = intervalTo;
    }

    // public Interval(): number
    // {
    //     return this.interval;
    // }

    protected IntervalTriggered(): void
    {
        this.SetNewInterval();
        this.callback();
    }

    protected SetNewInterval(): void
    {
        this.currentInterval = Math.floor(Math.random() * (this.intervalTo - this.intervalFrom)) + this.intervalFrom;
        this.intervalid = safeSetTimeout(() => this.IntervalTriggered(), this.currentInterval);
    }

    public Start(): void
    {
        if (this.running)
        {
            this.Stop();
        }

        this.running = true;
        this.SetNewInterval();
    }

    public Restart(): void
    {
        this.Start();
    }

    public Stop(): void
    {
        if (this.running)
        {
            this.running = false;
            safeClearTimeout(this.intervalid);
        }
    }

    public Running(): boolean
    {
        return this.running;
    }

    public Name(): string
    {
        return this.resid.ID()
    }
}